/**
 * Shared "unsaved changes" flag for the Settings screens (QA decision
 * 2026-07-04: warn before switching tabs with unsaved edits). Each Settings
 * section mirrors its local isModified state here; the tab shells consult it
 * before switching. A module-level flag (not context) on purpose: the sections
 * are cousins across two shells (BusinessComponent + SettingsPageComponent)
 * and this is read-at-click-time only — no re-render needed.
 */
let dirty = false;

export const setSettingsDirty = (value: boolean) => { dirty = value; };
export const isSettingsDirty = () => dirty;
